import { render, staticRenderFns } from "./CreateFIGMA.vue?vue&type=template&id=fbd9b640&"
import script from "./CreateFIGMA.vue?vue&type=script&lang=js&"
export * from "./CreateFIGMA.vue?vue&type=script&lang=js&"
import style0 from "./CreateFIGMA.vue?vue&type=style&index=0&id=fbd9b640&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports